import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from '../App';
import Profile from './Profile';
import Nominees from './Beneficiaries';
import NomineeShell from './NomineeShell';
import OwnerShell from './OwnerShell';

export default function Account() {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const [tab, setTab] = useState('profile');
  const navigate = useNavigate();
  const location = useLocation();

  if (!currentUser) return null;

  // Nominees should still have the left navigation pane, but with a simplified
  // menu. Reuse the embedded profile view so we don't render two sidebars.
  if (currentUser.type === 'nominee') {
    return (
      <NomineeShell>
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '20px 20px 40px' }}>
          <Profile embedded />
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
            <button
              type="button"
              onClick={() => {
                // Match owner logout UX: explicit logout forces a fresh Hosted UI login.
                try { window.sessionStorage.setItem('force_reauth', '1'); } catch {}
                setCurrentUser(null);
                navigate('/logout');
              }}
              style={{ background: 'var(--sage-600)', color: '#fff', border: 'none', borderRadius: 12, padding: '10px 14px', fontWeight: 600, cursor: 'pointer' }}
            >
              Log out
            </button>
          </div>
        </div>
      </NomineeShell>
    );
  }

  // Support deep-linking /account?tab=nominees and CTA navigation that sets state.tab.
  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search || '');
      const requested = (location.state && location.state.tab) || params.get('tab');
      if (requested === 'nominees') setTab('nominees');
      if (requested === 'profile') setTab('profile');
    } catch {}
  }, [location.search, location.state]);

  const setTabAndUrl = (nextTab) => {
    setTab(nextTab);
    try {
      const params = new URLSearchParams(location.search || '');
      params.set('tab', nextTab);
      navigate(`/account?${params.toString()}`, { replace: true, state: location.state || null });
    } catch {
      // Fallback if URLSearchParams fails for any reason.
      navigate(`/account?tab=${encodeURIComponent(nextTab)}`, { replace: true, state: location.state || null });
    }
  };

  const TabButton = ({ id, children }) => (
    <button
      onClick={() => setTabAndUrl(id)}
      style={{
        padding: '10px 16px',
        border: 'none',
        borderBottom: tab === id ? '3px solid var(--sage-600)' : '3px solid transparent',
        background: 'transparent',
        color: tab === id ? 'var(--dusk-700)' : '#666',
        fontWeight: 600,
        cursor: 'pointer'
      }}
    >{children}</button>
  );

  return (
    <OwnerShell>
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '20px 20px 40px' }}>
          <div style={{ display: 'flex', gap: 16, borderBottom: '1px solid var(--mist-300)', marginBottom: 16 }}>
            <TabButton id="profile">Your profile</TabButton>
            <TabButton id="nominees">Nominees</TabButton>
          </div>
          <div>
            {tab === 'profile' && (
              <Profile embedded />
            )}
            {tab === 'nominees' && (
              <Nominees embedded />
            )}
          </div>
      </div>
    </OwnerShell>
  );
}


